module.exports = __webpack_public_path__ + "img/palette.f0119f95.svg";